import React from "react";
import { Button } from "antd-mobile";

function CustomBottomButton(props) {
  const bottomBtnStyle = {
    position: "fixed",
    bottom: 0,
    height: "56px",
    borderRadius: "16px 16px 0 0",
    fontSize: "var(--fontSetting-bigger)",
    fontWeight: 700,
  };
  return (
    <Button
      block
      color="primary"
      size="large"
      style={bottomBtnStyle}
      {...props}
    >
      {props.children}
    </Button>
  );
}

export default CustomBottomButton;
